/**
* Image Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'image-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      /*
       * Since this is a radio group, when this is toggled, technically there are two toggles happening:
       * 1. The toggling off of the previously active column
       * 2. The toggling on of the newly active column
       *
       * Using i, we will keep track of which is which
       */
      let i = 0;
      $( '.image-accordion .column .title-bar' ).on( 'toggleAfter', ( event ) => {
        if ( i == 0 ) { // hide the content for the untoggled content
          $( event.target ).closest( '.column' ).find( '.content' ).attr( 'aria-hidden', 'true' );
          $( event.target ).closest( '.column' ).find( '.content a' ).attr( 'tabindex', '-1' );
          i++;
        } else { // show the content for the toggled content
          $( event.target ).closest( '.column' ).find( '.content' ).attr( 'aria-hidden', 'false' );
          $( event.target ).closest( '.column' ).find( '.content a' ).removeAttr( 'tabindex' );
          $( event.target ).closest( '.column' ).find( '.content' ).attr( 'tabindex', '0' ).focus().removeAttr( 'tabindex' );
          i = 0;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-accordion', COMPONENT );
} )( app );
